export const styleConfig = {
    header: {
        backgroundColor: '#F1FBFF',
        height: 54,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        marginBottom: 10,
    },
};
